export const REQUEST_LISTINGS: string = 'REQUEST_LISTINGS';
export const SET_LISTINGS: string = 'SET_LISTINGS';
export const REQUEST_LISTINGS_INTERVENANTS: string =
  'REQUEST_LISTINGS_INTERVENANTS';
export const SET_LISTINGS_INTERVENANTS: string = 'SET_LISTINGS_INTERVENANTS';
export const SET_KECLOAK_TOKEN: string = 'SET_KECLOAK_TOKEN';
export const REQUEST_GET_LAWYER_NOTIFICATIONS: string =
  'REQUEST_GET_LAWYER_NOTIFICATIONS';

export const REQUEST_GET_NOTIFICATIONS_INBOXES: string =
  'REQUEST_GET_NOTIFICATIONS_INBOXES';
export const SET_NOTIFICATIONS_INBOXES: string = 'SET_NOTIFICATIONS_INBOXES';

export const SET_LAWYER_NOTIFICATIONS: string = 'SET_LAWYER_NOTIFICATIONS';

export const REQUEST_GET_MANAGER_NOTIFICATIONS: string =
  'REQUEST_GET_MANAGER_NOTIFICATIONS';

export const SET_MANAGER_NOTIFICATIONS: string = 'SET_MANAGER_NOTIFICATIONS';

export const REQUEST_READ_LAWYER_NOTIFICATION: string =
  'REQUEST_READ_LAWYER_NOTIFICATION';

export const REQUEST_READ_MANAGER_NOTIFICATION: string =
  'REQUEST_READ_MANAGER_NOTIFICATION';

export const TOKEN_LIFE_SPAN_REMAIN_PERIOD = 10;
export const BIN_MANAGER_OPENING_MANAGER = 6;
export const BIN_MANAGER_COURT_MOUNITORING_MANAGER = 15;
export const BIN_MOUNITORING_COURT_MANAGER = 5;

export const SET_CURRENT_INSTANCE_TAB: string = 'SET_CURRENT_INSTANCE_TAB';

export const PATH_MANAGER = '/manager/legal-procedding/';
export const PATH_MONITORING_MANAGER = '/monitoring-manager/legal-procedding/';

export const PATH_LAWYER = '/legal-proceedings/';

export const REQUEST_LINK_BENEFICIARY_CODES: string =
  'REQUEST_LINK_BENEFICIARY_CODES';
export const SET_LINK_BENEFICIARY_CODES: string = 'SET_LINK_BENEFICIARY_CODES';
export const REQUEST_GET_EXPERT_NOTIFICATIONS: string =
  'REQUEST_GET_EXPERT_NOTIFICATIONS';
export const SET_EXPERT_NOTIFICATIONS: string = 'SET_EXPERT_NOTIFICATIONS';
export const REQUEST_READ_EXPERT_NOTIFICATION: string =
  'REQUEST_READ_EXPERT_NOTIFICATION';
export const REQUEST_NOTIFICATION_OPENING_MANAGER_MIXED_CLAIM: string =
  'REQUEST_NOTIFICATION_OPENING_MANAGER_MIXED_CLAIM';
export const SET_NOTIFICATION_OPENING_MANAGER_MIXED_CLAIM: string =
  'SET_NOTIFICATION_OPENING_MANAGER_MIXED_CLAIM';
export const DOCTOR_ROLE = 'medecin';
export const ACCOUNTING_ROLE = 'comptables';
export const MECHANIC_ROLE = 'mecanique';
export const LAWYER_ROLE = 'avocat';
export const SET_CLAIM_NUMBER: string = 'SET_CLAIM_NUMBER';
export const SET_NOTIFICATION: string = 'SET_NOTIFICATION';
export const SET_OPEN_UNLOCK_CLAIM_DIALOG: string =
  'SET_OPEN_UNLOCK_CLAIM_DIALOG';
export const REQUEST_FORCE_UNLOCK_CLAIM: string = 'REQUEST_FORCE_UNLOCK_CLAIM';
export const SET_CURRENT_INDEX_TAB_MANAGER: string =
  'SET_CURRENT_INDEX_TAB_MANAGER';
export const SET_CURRENT_INDEX_GLOBAL_TAB_MANAGER: string =
  'SET_CURRENT_INDEX_GLOBAL_TAB_MANAGER';

export const SET_CURRENT_INDEX_TAB_EXPERTISE: string =
  'SET_CURRENT_INDEX_TAB_EXPERTISE';
export const REQUEST_READ_CONVERT_CLAIM_NOTIFICATION: string =
  'REQUEST_READ_CONVERT_CLAIM_NOTIFICATION';

export const SET_CURRENT_INDEX_TAB_TRANSACTION: string =
  'SET_CURRENT_INDEX_TAB_TRANSACTION';
export const SET_TRANSACTION_ID: string = 'SET_TRANSACTION_ID';

export const SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_MANAGER: string =
  'SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_MANAGER';

export const REQUEST_GET_COUNT_NOTIFICATIONS_MANAGER: string =
  'REQUEST_GET_COUNT_NOTIFICATIONS_MANAGER';

export const REQUEST_SET_COUNT_NOTIFICATIONS_MANAGER: string =
  'REQUEST_SET_COUNT_NOTIFICATIONS_MANAGER';

export const SET_NOTIFICATION_FEE_NOTE: string = 'SET_NOTIFICATION_FEE_NOTE';

export const RESET_INDEX_TABS = 'RESET_INDEX_TABS';
export const NOTIFICATION_CLAIM_CONVERTION = 'CLAIM_CONVERTION';
export const REQUEST_REFRESH_MANAGER = 'REQUEST_REFRESH_MANAGER';

export const EXPERT_REJECTION_TITLE_NOTIFICATION =
  'a rejeté la réalisation de la mission';

export const ASSIGNEMENT_INBOXE_TITLE_NOTIFICATION =
  'veuillez cliquer sur la notification pour rafraichir votre boite de réception';
export const DELAY_MISSION_TITLE_MOTIFICATION =
  "Attention, la période entre la réception de la convocation et la date de l'expertise est inférieure à 5 jours.";

export const LAWYER_INTERVENANT_TYPE = '4';

export const SET_CURRENT_REGULATION_PATH: string =
  'SET_CURRENT_REGULATION_PATH';

export const REQUEST_GET_INBOXES_LAWYER_NOTIFICATIONS: string =
  'REQUEST_GET_INBOXES_LAWYER_NOTIFICATIONS';

export const SET_INBOXES_LAWYER_NOTIFICATIONS: string =
  'SET_INBOXES_LAWYER_NOTIFICATIONS';

export const REQUEST_GET_COUNT_INBOXES_LAWYER_NOTIFICATIONS: string =
  'REQUEST_GET_COUNT_INBOXES_LAWYER_NOTIFICATIONS';

export const SET_COUNT_INBOXES_LAWYER_NOTIFICATIONS: string =
  'SET_COUNT_INBOXES_LAWYER_NOTIFICATIONS';

export const SET_CURRENT_INDEX_GLOBAL_TAB_LAWYER: string =
  'SET_CURRENT_INDEX_GLOBAL_TAB_LAWYER';

export const SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_LAWYER: string =
  'SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_LAWYER';
export const SET_CURRENT_INDEX_TAB_LAWYER: string =
  'SET_CURRENT_INDEX_TAB_LAWYER';

export const SETTLEMENT_PHASE = {
  JUDICIARY: 'JUDICIARY',
  TRANSACTION: 'TRANSACTION',
};
